import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import Col from "react-bootstrap/Col";

import { useState, useEffect, useContext } from "react";
import { isEmpty } from "lodash";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import ListPage from "./Home/ListPage";
import Layout from "./Layout";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AuthContext from "../context/AuthContext";
import Banner01 from "../img/banner-01.png";
import Banner02 from "../img/banner-02.png";
import Banner03 from "../img/banner-03.png";
import Banner04 from "../img/banner-04.png";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/bundle";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
const Home = () => {
  const { sportType } = useParams();
  const { t } = useTranslation();
  const [banner, setBanner] = useState([]);
  const { user } = useContext(AuthContext);
  let getBannerData = async () => {
    const data = await apiGet(apiPath.getBanner, {
      type: "home_top",
      userId: !isEmpty(user) ? user?.user?._id : "",
      device: "web",
    });
    if (data?.status == 200) {
      if (data?.data?.success) {
        setBanner(
          data?.data?.results?.banners?.filter((res) => {
            return res?.isForWeb;
          })
        );
      }
    }
  };
  useEffect(() => {
    getBannerData();
  }, [user]);

  const list = [
    { image: Banner01 },
    { image: Banner02 },
    { image: Banner03 },
    { image: Banner04 },
  ];

  return (
    <Layout>
      <Col
        md={9}
        style={{ padding: "0 5px" }}
        // style={{ height: "calc(100vh - 10px)", overflow: "scroll" }}
      >
        {isEmpty(sportType) && (
          <Swiper
            modules={[Autoplay]}
            spaceBetween={30}
            autoplay={{ delay: 3000 }}
            loop
          >
            {(banner?.length > 0 ? banner : list)?.map((res) => {
              return (
                <SwiperSlide>
                  <img
                    src={
                      banner?.length > 0
                        ? `${process.env.REACT_APP_API_BASE_URL}${res?.banner_path}`
                        : res?.image
                    }
                    style={{
                      width: "100%",
                      height: "300px",
                      objectFit: "cover",
                      verticalAlign: "middle",
                    }}
                  />
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
        <ListPage type="in_play" heading="InPlay" />
      </Col>

      {/* <ListPage type="today" heading="Upcoming" /> */}
      {/* <div
      data-aos="zoom-in-down"
      data-aos-easing="ease"
      data-aos-delay="400"
      className=" br-6 mb-3"
    >
      <h2 className="mb-3">
        <img src={live} /> Inplay{" "}
        <span className="float-end">
          <img src={UpcomingDark} /> Upcoming
        </span>
      </h2>

      <div className="leagueBox">
        <div className="title">
          <Row>
            <Col md={7}>
              <span className="live">LIVE</span>
              <img
                src={BatBlue}
                style={{ maxWidth: "20px" }}
              />{" "}
              Cricket
            </Col>
            <Col md={5} className="text-dark text-center">
              <Row>
                <Col className="text-center" md={4}>
                  1
                </Col>
                <Col className="text-center" md={4}>
                  2
                </Col>
                <Col className="text-center" md={4}>
                  3
                </Col>
              </Row>
            </Col>
          </Row>
        </div>

        <div className="laegueRow">
          <Row>
            <Col md={7} className="text-blue">
              <img src={trophy} style={{ maxWidth: "20px" }} />{" "}
              Twenty20 ICC World Cup
            </Col>
            <Col md={5} className="text-dark text-center">
              <img src={telecase} style={{ maxWidth: "25px" }} />
            </Col>
          </Row>
        </div>
        <div className="laegueRow active">
          <Row>
            <Col md={7}>
              <Row className="mb-1">
                <Col md={5}>
                  <img
                    src={IndFlag}
                    style={{ maxWidth: "20px" }}
                  />{" "}
                  India
                </Col>
                <Col md={7}>175/7</Col>
              </Row>
              <Row>
                <Col md={5}>
                  <img
                    src={PakFlag}
                    style={{ maxWidth: "20px" }}
                  />{" "}
                  India
                </Col>
                <Col md={7}>176/9 (15.5)</Col>
              </Row>
            </Col>
            <Col md={5} className="text-dark text-center">
              <Row className="mx-0">
                <Col className="text-center px-0" md={4}>
                  <div className="d-flex">
                    <div className="bluBoxs">
                      3.63<span>14532</span>
                    </div>
                    <div className="redBoxs">
                      3.63<span>14532</span>
                    </div>
                  </div>
                </Col>
                <Col className="text-center px-0" md={4}>
                  <div className="d-flex">
                    <div className="whiteBoxes">-</div>
                    <div className="whiteBoxes">-</div>
                  </div>
                </Col>
                <Col className="text-center px-0" md={4}>
                  <div className="d-flex">
                    <div className="bluBoxs">
                      3.63<span>14532</span>
                    </div>
                    <div className="redBoxs">
                      3.63<span>14532</span>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <div className="laegueRow">
          <Row>
            <Col md={7}>
              <Row className="mb-1">
                <Col md={5}>
                  <img
                    src={IndFlag}
                    style={{ maxWidth: "20px" }}
                  />{" "}
                  India
                </Col>
                <Col md={7}>175/7</Col>
              </Row>
              <Row>
                <Col md={5}>
                  <img
                    src={PakFlag}
                    style={{ maxWidth: "20px" }}
                  />{" "}
                  India
                </Col>
                <Col md={7}>176/9 (15.5)</Col>
              </Row>
            </Col>
            <Col md={5} className="text-dark text-center">
              <Row className="mx-0">
                <Col className="text-center px-0" md={4}>
                  <div className="d-flex">
                    <div className="bluBoxs">
                      3.63<span>14532</span>
                    </div>
                    <div className="redBoxs">
                      3.63<span>14532</span>
                    </div>
                  </div>
                </Col>
                <Col className="text-center px-0" md={4}>
                  <div className="d-flex">
                    <div className="whiteBoxes">-</div>
                    <div className="whiteBoxes">-</div>
                  </div>
                </Col>
                <Col className="text-center px-0" md={4}>
                  <div className="d-flex">
                    <div className="bluBoxs">
                      3.63<span>14532</span>
                    </div>
                    <div className="redBoxs">
                      3.63<span>14532</span>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <div className="laegueRow greyBG">
          <Row>
            <Col md={7}>
              <Row className="mb-1">
                <Col md={5}>
                  <img
                    src={IndFlag}
                    style={{ maxWidth: "20px" }}
                  />{" "}
                  India
                </Col>
                <Col md={7}>175/7</Col>
              </Row>
              <Row>
                <Col md={5}>
                  <img
                    src={PakFlag}
                    style={{ maxWidth: "20px" }}
                  />{" "}
                  India
                </Col>
                <Col md={7}>176/9 (15.5)</Col>
              </Row>
            </Col>
            <Col md={5} className="text-dark text-center">
              <Row className="mx-0">
                <Col className="text-center px-0" md={4}>
                  <div className="d-flex">
                    <div className="bluBoxs">
                      3.63<span>14532</span>
                    </div>
                    <div className="redBoxs">
                      3.63<span>14532</span>
                    </div>
                  </div>
                </Col>
                <Col className="text-center px-0" md={4}>
                  <div className="d-flex">
                    <div className="whiteBoxes">-</div>
                    <div className="whiteBoxes">-</div>
                  </div>
                </Col>
                <Col className="text-center px-0" md={4}>
                  <div className="d-flex">
                    <div className="bluBoxs">
                      3.63<span>14532</span>
                    </div>
                    <div className="redBoxs">
                      3.63<span>14532</span>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </div>

    <div
      data-aos="zoom-in-left"
      data-aos-easing="ease"
      data-aos-delay="400"
      className="m-banner mb-3"
    >
      <img src={MBanner} />
    </div>
    <div
      data-aos="zoom-in-right"
      data-aos-easing="ease"
      data-aos-delay="400"
      className=" mb-3"
    >
      <h2 className="mb-3">
        <img src={upcoming} /> Upcoming{" "}
        <span className="float-end">
          <img src={InPlayDark} /> Inplay
        </span>
      </h2>

      <div className="leagueBox">
        <div className="title">
          <Row>
            <Col md={7}>
              <span className="live">LIVE</span>
              <img
                src={Racket}
                style={{ maxWidth: "20px" }}
              />{" "}
              Tennis
            </Col>
            <Col md={5} className="text-dark text-center">
              <Row>
                <Col className="text-center" md={4}>
                  1
                </Col>
                <Col className="text-center" md={4}>
                  2
                </Col>
                <Col className="text-center" md={4}>
                  3
                </Col>
              </Row>
            </Col>
          </Row>
        </div>

        <div className="laegueRow">
          <Row>
            <Col md={7} className="text-blue">
              <img src={trophy} style={{ maxWidth: "20px" }} />{" "}
              Twenty20 ICC World Cup
            </Col>
            <Col md={5} className="text-dark text-center">
              <img src={telecase} style={{ maxWidth: "25px" }} />
            </Col>
          </Row>
        </div>
        <div className="laegueRow active">
          <Row>
            <Col md={7}>
              <Row className="mb-1">
                <Col md={5}>
                  <img
                    src={IndFlag}
                    style={{ maxWidth: "20px" }}
                  />{" "}
                  India
                </Col>
                <Col md={7}>175/7</Col>
              </Row>
              <Row>
                <Col md={5}>
                  <img
                    src={PakFlag}
                    style={{ maxWidth: "20px" }}
                  />{" "}
                  India
                </Col>
                <Col md={7}>176/9 (15.5)</Col>
              </Row>
            </Col>
            <Col md={5} className="text-dark text-center">
              <Row className="mx-0">
                <Col className="text-center px-0" md={4}>
                  <div className="d-flex">
                    <div className="bluBoxs">
                      3.63<span>14532</span>
                    </div>
                    <div className="redBoxs">
                      3.63<span>14532</span>
                    </div>
                  </div>
                </Col>
                <Col className="text-center px-0" md={4}>
                  <div className="d-flex">
                    <div className="whiteBoxes">-</div>
                    <div className="whiteBoxes">-</div>
                  </div>
                </Col>
                <Col className="text-center px-0" md={4}>
                  <div className="d-flex">
                    <div className="bluBoxs">
                      3.63<span>14532</span>
                    </div>
                    <div className="redBoxs">
                      3.63<span>14532</span>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <div className="laegueRow">
          <Row>
            <Col md={7}>
              <Row className="mb-1">
                <Col md={5}>
                  <img
                    src={IndFlag}
                    style={{ maxWidth: "20px" }}
                  />{" "}
                  India
                </Col>
                <Col md={7}>175/7</Col>
              </Row>
              <Row>
                <Col md={5}>
                  <img
                    src={PakFlag}
                    style={{ maxWidth: "20px" }}
                  />{" "}
                  India
                </Col>
                <Col md={7}>176/9 (15.5)</Col>
              </Row>
            </Col>
            <Col md={5} className="text-dark text-center">
              <Row className="mx-0">
                <Col className="text-center px-0" md={4}>
                  <div className="d-flex">
                    <div className="bluBoxs">
                      3.63<span>14532</span>
                    </div>
                    <div className="redBoxs">
                      3.63<span>14532</span>
                    </div>
                  </div>
                </Col>
                <Col className="text-center px-0" md={4}>
                  <div className="d-flex">
                    <div className="whiteBoxes">-</div>
                    <div className="whiteBoxes">-</div>
                  </div>
                </Col>
                <Col className="text-center px-0" md={4}>
                  <div className="d-flex">
                    <div className="bluBoxs">
                      3.63<span>14532</span>
                    </div>
                    <div className="redBoxs">
                      3.63<span>14532</span>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <div className="laegueRow greyBG">
          <Row>
            <Col md={7}>
              <Row className="mb-1">
                <Col md={5}>
                  <img
                    src={IndFlag}
                    style={{ maxWidth: "20px" }}
                  />{" "}
                  India
                </Col>
                <Col md={7}>175/7</Col>
              </Row>
              <Row>
                <Col md={5}>
                  <img
                    src={PakFlag}
                    style={{ maxWidth: "20px" }}
                  />{" "}
                  India
                </Col>
                <Col md={7}>176/9 (15.5)</Col>
              </Row>
            </Col>
            <Col md={5} className="text-dark text-center">
              <Row className="mx-0">
                <Col className="text-center px-0" md={4}>
                  <div className="d-flex">
                    <div className="bluBoxs">
                      3.63<span>14532</span>
                    </div>
                    <div className="redBoxs">
                      3.63<span>14532</span>
                    </div>
                  </div>
                </Col>
                <Col className="text-center px-0" md={4}>
                  <div className="d-flex">
                    <div className="whiteBoxes">-</div>
                    <div className="whiteBoxes">-</div>
                  </div>
                </Col>
                <Col className="text-center px-0" md={4}>
                  <div className="d-flex">
                    <div className="bluBoxs">
                      3.63<span>14532</span>
                    </div>
                    <div className="redBoxs">
                      3.63<span>14532</span>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </div> */}
    </Layout>
  );
};

export default Home;
